import { AnnotationFields } from "../../../../types";
import { productMutableFields } from "../../../../productMutableFields";
import { ValueRenderOrder } from "../../types";

export const MIN_TEXTAREA_TEXT_LENGTH = 50;

export const inputProductTypesMapping = productMutableFields
  .filter(({ type }) => type === "string" || type === "number")
  .map(({ name, baseName, type }) => {
    return {
      name: name as AnnotationFields,
      baseName,
      type: type === "string" ? "text" : "number",
    };
  });

export const valueRenderData: ValueRenderOrder[] = [
  { valueKind: "actual" },
  { valueKind: "predicted", checkUniquenessVersus: "confirmed" },
  { valueKind: "confirmed", checkUniquenessVersus: "predicted" },
];
